import { Box, ListItem, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function SendToReviewResultFailedRow({ schedule }) {
    const { title, code, reason } = schedule
    return (
        <ListItem
            data-cy="send-to-review-result-failed-row"
            sx={{ borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}
        >
            <Stack direction="row" spacing={2} alignItems="center" sx={{ width: 1 }}>
                <Iconify icon="quill:paper" sx={{ width: 24, height: 24, color: "text.secondary" }} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" noWrap>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        #{code}
                    </Typography>
                    <Typography variant="caption" color="error.main">
                        {reason}
                    </Typography>
                </Box>
            </Stack>
        </ListItem>
    )
}
